import { useLocation } from 'react-router-dom'

export const useCurrentPage = () => {
  const { pathname } = useLocation()

  const firstLevelPathname = pathname.split('/').pop()
  return firstLevelPathname ?? ''
}
